import { createSlice, current, PayloadAction } from '@reduxjs/toolkit';

export enum NotificationType {
  /** Success Notification */
  Success = 1,
  /** Warning Notification */
  Warning = 2,
  /** Error Notification */
  Error = 3,
  /** Info Notification */
  Informational = 4,
}

export enum TopBannerContentType {
  AppListEnvironment = 'AppListEnvironment',
}

export interface ErrorContext {
  errorCode: string;
  correlationId?: string;
  timestamp?: string;
  statusCode?: number;
}

export interface INotification {
  message: string;
  type: NotificationType;
  show: boolean;
  dismissAfter?: number;
  autoDismiss: boolean;
  errorContext?: ErrorContext;
  externalLink?: string;
}

export interface ITopBanner {
  type: TopBannerContentType;
  show: boolean;
}

export const notificationSlice = createSlice({
  name: 'notification',
  initialState: {
    notification: undefined as INotification | undefined,
    topBanner: undefined as ITopBanner | undefined,
  },
  reducers: {
    showNotification: (state, action: PayloadAction<INotification>) => {
      state.notification = action.payload;
    },
    dismissNotification: (state) => {
      state.notification = undefined;
    },
    showTopBanner: (state, action: PayloadAction<ITopBanner>) => {
      state.topBanner = action.payload;
    },
    dismissTopBanner: (state) => {
      state.topBanner = undefined;
    },
  },
  selectors: {
    currentNotification: (state) => state.notification,
    currentTopBanner: (state) => state.topBanner,
  },
});
